<template>
  <div class="main-container">
      <div class="container__alert">

          <div class="alert alert--error alert__errorConnexion" v-if="wrongPinModal">
              <div class="alert__header">
                  <div class="alert__title">
                      <p>{{translationArray.error_connection}}</p>
                  </div>
                  <hr>
              </div>
              
              <div class="alert__body">
                  <div class="alert__image">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.340562 19.6125C-0.425702 18.9151 0.340562 17.8689 0.340562 17.8689L8.3095 9.88624L0.512983 2.00191C0.512983 2.00191 -0.360283 0.994184 0.512983 0.258302C1.20265 -0.322869 2.06476 0.258287 2.06476 0.258287L9.99612 8.19672L17.7551 0.43265C17.7551 0.43265 18.7896 -0.43915 19.6517 0.43265C20.3414 1.13006 19.6517 2.00191 19.6517 2.00191L11.6341 9.76105L19.6517 17.8689C19.6517 17.8689 20.4354 18.7407 19.6517 19.6125C18.868 20.4843 17.7551 19.6125 17.7551 19.6125L9.8237 11.5919L1.89235 19.6125C1.89235 19.6125 1.10683 20.31 0.340562 19.6125Z" fill="white" fill-opacity="0.9"/>
                          </svg>                                
                  </div>
                  <div class="alert__description">
                      <p v-if="!statusWallet">{{translationArray.wallet_disable}}</p>
                      <p v-if="statusWallet">{{translationArray.wrong_pin_0}}{{amountTry}}{{translationArray.wrong_pin_1}}</p>
                  </div>
              </div>
          </div>

          <div class="alert alert__connexion tag__connection" v-if="loadingConnection">
              <div class="alert__header">
                  <div class="alert__title">
                      <p>{{translationArray.connecting}}</p>
                      <div class="loading">
                          <div class="animateSpin">
                              <div class="loader">
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="container__modal" v-if="modalDisplay">
          <div class="modal modal__askPIN" v-if="modalWarning">
              <div class="modal__content">
                      <p class="modal__title">{{translationArray.be_careful}}</p>
                      <div class="modal_image">
                        <img src="../../static/img/asknfc.png">
                      </div>
                      
                          
                      <p class="modal__description">{{translationArray.enable_option_0}}<span class="bold">{{this.$senzuAuth.nameClient}}</span>{{translationArray.enable_option_1}}
                          <span>
                              {{translationArray.more_info}}
                          </span>
                      </p>
                      <div class="modal__btn">
                          <button class="modal__btn__cancel btn btn__red" @click="updateModal()">{{translationArray.cancel}}</button>
                          <button class="modal__btn__confirm btn btn__green" @click="updateModal(true)">{{translationArray.confirm}}</button>
                      </div>
                  </div>
          </div>
      </div>

      <header class="headerBlue padding-bottom-10">
          <svg class="waves" width="455" height="455" viewBox="0 0 455 455" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="227.949" cy="227.949" r="124.244" stroke="#3CB5A8"/>
            <circle cx="227.949" cy="227.948" r="173.603" stroke="#3CB5A8" stroke-opacity="0.4"/>
            <circle cx="227.5" cy="227.5" r="227" stroke="#3CB5A8" stroke-opacity="0.1"/>
          </svg>
          <a @click="historyBack()" class="btnBack">
              <span class="btnBack__svg">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="arrow_back_24px">
                  <path id="icon/navigation/arrow_back_24px" d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#3CB5A8"/>
                  </g>
                  </svg>
              </span>
          </a>
          <div class="containerTitle">
              <h1>{{translationArray.connection}}</h1>
              <p><span>{{translationArray.on}}</span><span>{{this.$senzuAuth.nameClient}}</span></p>
          </div>

          <div class="containerPartner">
              <div class="partnerBox partnerBox__Left" v-if="!isSenzuApp">
                  <img v-if="this.$senzuAuth.hasImageClient == 'false'" src="../../static/img/logo.png" :alt="'image_' + this.$senzuAuth.nameClient">
                  <img v-else :src="this.$senzuAuth.urlImageClient" :alt="'image_' + this.$senzuAuth.nameClient">
              </div>
              <div class="partnerSeparation" v-if="!isSenzuApp">
                  <svg width="34" height="54" viewBox="0 0 34 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M33.0607 13.0607C33.6464 12.4749 33.6464 11.5251 33.0607 10.9393L23.5147 1.3934C22.9289 0.807611 21.9792 0.807611 21.3934 1.3934C20.8076 1.97919 20.8076 2.92893 21.3934 3.51472L29.8787 12L21.3934 20.4853C20.8076 21.0711 20.8076 22.0208 21.3934 22.6066C21.9792 23.1924 22.9289 23.1924 23.5147 22.6066L33.0607 13.0607ZM1 13.5H32V10.5H1V13.5Z" fill="#EEEEEE"/>
                      <path d="M0.939339 40.9393C0.353554 41.5251 0.353554 42.4749 0.939339 43.0607L10.4853 52.6066C11.0711 53.1924 12.0208 53.1924 12.6066 52.6066C13.1924 52.0208 13.1924 51.0711 12.6066 50.4853L4.12132 42L12.6066 33.5147C13.1924 32.9289 13.1924 31.9792 12.6066 31.3934C12.0208 30.8076 11.0711 30.8076 10.4853 31.3934L0.939339 40.9393ZM33 40.5H2V43.5H33V40.5Z" fill="#EEEEEE"/>
                  </svg>                    
              </div>
              <div class=" partnerBox partnerBox__Right">
                  <img src="../../static/img/senzu.png" alt="">
              </div>  
          </div>
          <div class="containerDescription">

              <p class="information__title__computer">{{translationArray.enter_pin}}</p>

              <p class="containerDescription__p">{{translationArray.valid_pin}}</p>
          </div>
          
      </header>
      <section class="bodyBlue body__PIN">
          <div class="userBox" v-bind:class="{'userBox-1': fromAuthorize, 'userBox--opacity': !fromAuthorize}"> <!-- Delete userBox-1 !-->
              <div class="contentImgUser">
                  <div class="imgUser">
                    <img :src="user.urlImage" :alt="user.id">
                  </div>
              </div>
              <div class="contentInfoUser">
                <p><span class="contentInfoUser__name">{{user.firstname}} {{user.lastname}}</span></p>
                <p><span class="contentInfoUser__description" v-if="isMobile">{{digitPin}}</span></p>
              </div>
          </div>

          <p class="bodyBlue--title">
              {{translationArray.valid_pin_connect}}
          </p>
          <div class="container__passwordBox">
              <div class="passwordBox passwordBox--empty"></div>
              <div class="passwordBox passwordBox--empty"></div>
              <div class="passwordBox passwordBox--empty"></div>
              <div class="passwordBox passwordBox--empty"></div>
              <div class="passwordBox passwordBox--empty"></div>
              <div class="passwordBox passwordBox--empty"></div>
          </div>
          <div class="container--digit">
            <div class="cell cell-nb" v-for="n in numbersPin" :key="n" @click="addDigit(n)">{{n}}</div>
            <div class="cell cell-back cell-11" @click="removeDigit()">
                <svg width="41" height="22" viewBox="0 0 41 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.9535 5.44436L30.4833 16.5553M30.4833 5.44436L19.9535 16.5553M12.9707 1C14.7356 1 37.4498 1.00081 38.9071 1C40.3643 0.999186 40.3643 20.9988 38.9071 20.9996C37.4498 21.0005 14.1217 20.9996 12.9707 20.9996C11.8196 20.9996 1.00002 11.9968 1 11C0.999981 10.0032 11.2057 1 12.9707 1Z" stroke="black" stroke-width="2"></path>
                </svg>
            </div>
          </div>

          <div class="askPin">
              <input type="checkbox" class="greenCheckbox" id="group16627" name="16627" value="16627" v-model="checkboxPin">
              <label for="group16627"></label>
              <p>{{translationArray.not_ask_pin}}</p>
          </div>
          <div class="submit submit__display" @click="checkPin()"><p>{{translationArray.valid_pin}}</p></div>
      </section>
  </div>
</template>

<script>

import {translate} from '../../static/js/translate';

export default {
  name: 'AskPin',
  data () {
    return {
      numbersPin: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      user: {},
      modalDisplay: false,
      modalWarning: false,
      isSenzuApp: false,
      digitPin: "",
      digitFinal: "",
      isNtag424: localStorage.getItem("ntag424"),
      savedMe: false,
      wrongPinModal: false,
      loadingConnection: false,
      amountTry: 3,
      statusWallet: true,
      checkboxPin: false,
      isDesktop: false,
      isMobile: true,
      urlImageUser: null,
      firstnameUser: null,
      lastnameUser: null,
      translationArray: {},
      fromAuthorize: (localStorage.getItem("last_page") === "Authorize"),
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  mounted() {
    this.translationArray = translate(navigator.language.substr(0, 2));

    let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
    if(clientId <= 8 || typeof(clientId) == 'undefined') {
        this.isSenzuApp = true;
    }

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.$senzuAuth.nameClient = localStorage.getItem("name_client");
    this.$senzuAuth.urlImageClient = localStorage.getItem("url_image_client");
    this.$senzuAuth.hasImageClient = localStorage.getItem("has_image_client");

    this.numbersPin = this.numbersPin
    .map((a) => ({sort: Math.random(), value: a}))
    .sort((a, b) => a.sort - b.sort)
    .map((a) => a.value)

    let idUser = this.$route.query.id_user;
    let idRecord = this.$route.query.id_record;
    let keyRecord = this.$route.query.key;

    this.urlImageUser = localStorage.getItem("url_image_user");
    this.firstnameUser = localStorage.getItem("firstname_user");
    this.lastnameUser = localStorage.getItem("lastname_user");

    if(this.isNtag424 == "false") {
        document.getElementsByClassName("askPin")[0].remove();
    }
    

    fetch(`${this.$origin}/nfc/users?id_record=${idRecord}&key=${keyRecord}&client_id=${clientId}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'CSRF-Token': this.csrfToken
        },
    }).then(result => result.json())
        .then(data => {
            this.user = data.result;
            this.user.forEach(function(element, key, object) {
              if(element.id != idUser) {
                object.splice(key, 1);
              }
            });
            this.user = this.user[0];

            if(this.firstnameUser != "null" && this.lastnameUser != "null") {
              this.user.urlImage = this.urlImageUser;
              this.user.firstname = this.firstnameUser;
              this.user.lastname = this.lastnameUser;
            }
        });
  },
  watch: {
    checkboxPin: function(value) {
      if(value) {
        this.modalDisplay = true;
        this.modalWarning = true;
      } else {
        this.savedMe = false;
      }
    },
    wrongPinModal: function(value) {
      let _this = this;
      var interval = setInterval(function() {
          _this.wrongPinModal = false;
          clearInterval(interval);
      }, 5800);
    },
  },
  methods: {
    handleResize: function() {
      if(window.innerWidth <= 1120) {
          this.isMobile = true;
          this.isDesktop = false;
      } else {
          this.isMobile = false;
          this.isDesktop = true;
      }
    },
    historyBack: function() {
      let query = {};
      let lastPage = null;
      if(localStorage.getItem("last_page") === "ChooseUsers" || localStorage.getItem("last_page") === "QrCode") {
        lastPage = localStorage.getItem("last_page");
        this.$senzuAuth.lastPage = "Authorize";
        localStorage.setItem("last_page", "Authorize");
        query = {
          id_record: this.$route.query.id_record,
          key: this.$route.query.key,
          client_id: this.$route.query.client_id, 
          redirect_uri: this.$route.query.redirect_uri,
          response_type: this.$route.query.response_type,
          scope: this.$route.query.scope,
          code_challenge: this.$route.query.code_challenge,
          code_challenge_method: this.$route.query.code_challenge_method,
          state: this.$route.query.state,
        }
      } else {
        lastPage = "Authorize";
        query = {
          client_id: this.$route.query.client_id, 
          redirect_uri: this.$route.query.redirect_uri,
          response_type: this.$route.query.response_type,
          scope: this.$route.query.scope,
          code_challenge: this.$route.query.code_challenge,
          code_challenge_method: this.$route.query.code_challenge_method,
          state: this.$route.query.state,
        }
      }

      this.$router.replace({name: lastPage, query});
    },
    updateModal: function(value) {
      if(this.modalWarning) {
        this.modalWarning = false;
        this.modalDisplay = false;
      } else {
        this.modalDisplay = true;
        this.modalWarning = true;        
      }
      if(value) {
          this.savedMe = true;
      } else {
          this.checkboxPin = false;
      }
    },
    addDigit: function(number) {
      let boxes = $(".passwordBox--empty");
      boxes.first().addClass('passwordBox--enter');
      boxes.first().removeClass('passwordBox--empty');

      if(this.digitPin.length < 6) {
        this.digitFinal += number;
        this.digitPin += "*";
      }
    },
    removeDigit: function() {
      let boxes = $(".passwordBox--enter");
      boxes.last().addClass('passwordBox--empty');
      boxes.last().removeClass('passwordBox--enter');

      if(this.digitPin.length > 0) {
        this.digitPin = this.digitPin.substring(0, this.digitPin.length - 1);
        this.digitFinal = this.digitFinal.substring(0, this.digitFinal.length - 1);
      }
    },
    checkPin: function() {
      let params = "id_record=" + this.$route.query.id_record + "&key=" + this.$route.query.key + "&id_user=" + this.$route.query.id_user + 
      "&client_id=" + this.$route.query.client_id + "&redirect_uri=" + this.$route.query.redirect_uri +
      "&response_type=" + this.$route.query.response_type + "&scope=" + this.$route.query.scope + 
      "&code_challenge=" + this.$route.query.code_challenge + "&code_challenge_method=" + this.$route.query.code_challenge_method +
      "&state=" + this.$route.query.state;

      if(this.digitFinal.length === 6) {
        fetch(`${this.$origin}/check-pin?${params}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'CSRF-Token': this.csrfToken
            },
            body: JSON.stringify({pin: this.digitFinal, savedMe: this.savedMe})
        }).then(result => result.json())
        .then(data => {
          if(typeof(data.redirect_uri) !== 'undefined') {
            this.loadingConnection = true;
            //window.history.pushState({}, '', "https://oauth.senzu.app");
            const intervalAbort = setInterval(function() {
                clearInterval(intervalAbort);
                this.$router.replace({name: "Authorize", query: {
                        client_id: this.$route.query.client_id,
                        redirect_uri: this.$route.query.redirect_uri,
                        response_type: this.$route.query.response_type,
                        scope: this.$route.query.scope,
                        code_challenge: this.$route.query.code_challenge,
                        code_challenge_method: this.$route.query.code_challenge_method,
                        state: this.$route.query.state,
                    }
                });
            }, 5000);
            window.location.replace(data.redirect_uri);
          } else if(typeof(data.redirect_roles) !== 'undefined') {
            this.$router.replace({name: 'AskRoles', query: {
              client_id: this.$route.query.client_id,
              redirect_uri: this.$route.query.redirect_uri,
              response_type: this.$route.query.response_type,
              scope: this.$route.query.scope,
              code_challenge: this.$route.query.code_challenge,
              code_challenge_method: this.$route.query.code_challenge_method,
              state: this.$route.query.state,
            }});
          } else {
            this.wrongPinModal = true;
            this.amountTry = data.amount_try;
            this.statusWallet = data.status;
            this.digitFinal = "";
            this.digitPin = "";
          }
        });
      }
    },
    abortRedirect: function() {
      this.$router.replace({name: "Authorize", query: {
          client_id: this.$route.query.client_id, 
          redirect_uri: this.$route.query.redirect_uri,
          response_type: this.$route.query.response_type,
          scope: this.$route.query.scope,
          code_challenge: this.$route.query.code_challenge,
          code_challenge_method: this.$route.query.code_challenge_method,
          state: this.$route.query.state,
        }
      });
      clearInterval(intervalAbort);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AskPin.vue